export default class Faq {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    this.el.querySelectorAll('.faq--trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.faq--item')
        const isOpen = item.classList.contains('faq--item--open')

        this.el.querySelectorAll('.faq--item--open').forEach(open => this._close(open))

        if (!isOpen) this._open(item)
      })
    })
  }

  _open(item) {
    const response = item.querySelector('.faq--response')
    if (!response) return
    item.classList.add('faq--item--open')
    response.style.height = '0px'
    response.offsetHeight
    response.style.height = response.scrollHeight + 'px'
    response.addEventListener('transitionend', () => {
      response.style.height = 'auto'
    }, { once: true })
  }

  _close(item) {
    const response = item.querySelector('.faq--response')
    if (!response) return
    response.style.height = response.getBoundingClientRect().height + 'px'
    response.offsetHeight
    response.style.height = '0px'
    item.classList.remove('faq--item--open')
  }
}
